import {Component, EventEmitter, Input, Output} from "@angular/core";
import {localizationKey} from "../../../../i18n/i18n-model";
import {SupportedLanguagesProvider} from "../../../../tools/supported-languages-provider";
import {SelectOption} from "../../../../tools/select/select.component";
import {ReportLanguageSettings} from "../../report-language-settings";

@Component({
  selector: "app-report-language-section",
  templateUrl: "./report-language-section.component.html",
  standalone: false
})
export class ReportLanguageSectionComponent {

  @Input() language!: string;
  @Input() reportLanguageSelectionEnabled!: boolean;
  @Input() allowedReportLanguages!: string[];

  @Output() settingsChanged = new EventEmitter<ReportLanguageSettings>();

  protected readonly localizationKey = localizationKey;

  readonly languageSelectionOptions: SelectOption[];

  constructor(supportedLanguagesProvider: SupportedLanguagesProvider) {
    this.languageSelectionOptions = supportedLanguagesProvider.getSelectionOptions();
  }

  isAllowed(language: string): boolean {
    return language === this.language || this.allowedReportLanguages.includes(language);
  }

  isDisabled(language: string): boolean {
    return language === this.language;
  }

  onReportLanguageSelectionEnabledChange(value: boolean) {
    this.reportLanguageSelectionEnabled = value;
    this.emitSettings();
  }

  onLanguageChange(value: string) {
    this.allowedReportLanguages = [...this.allowedReportLanguages, this.language].filter(allowed => allowed !== value);
    this.language = value;
    this.emitSettings();
  }

  onAllowedReportLanguageChange(language: string, selected: boolean) {
    this.allowedReportLanguages = selected
      ? [...this.allowedReportLanguages, language]
      : this.allowedReportLanguages.filter(allowed => allowed !== language);
    this.emitSettings();
  }

  private emitSettings() {
    this.settingsChanged.emit({
      language: this.language,
      reportLanguageSelectionEnabled: this.reportLanguageSelectionEnabled,
      allowedReportLanguages: this.allowedReportLanguages
    });
  }
}
